export default __webpack_public_path__ + "assets/af4e6c197da21a82ad114a6f519b986e.svg";